export default class ChartError extends Error {
  constructor(msg: string, code: string = '') {
    super(msg)

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, ChartError.prototype)
  }
}
